/**
 * Settings → Diagnostics. Its own page, not a General hash.
 */

import { DiagnosticsSection } from "./DiagnosticsSettingsPanel";
import { useDiagnosticsPrototypeVariant } from "./diagnosticsPrototype/useDiagnosticsPrototypeVariant";
import { SettingsPageContainer } from "./settingsLayout";

export function DiagnosticsSettings() {
  // PROTOTYPE: variant D uses upstream's expanded rail and section gap.
  const [variant] = useDiagnosticsPrototypeVariant();
  return (
    <SettingsPageContainer {...(variant === "D" ? { className: "max-w-6xl md:gap-10" } : {})}>
      <DiagnosticsSection />
    </SettingsPageContainer>
  );
}
